import type { RouteRecordRaw } from 'vue-router';
import HomePage from './pages/HomePage.vue';
export const HomeRouting: RouteRecordRaw[] = [
  {
    path: '/',
    component: HomePage,
  },
];
